// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kKbDA","subscribe":"Footer_subscribe__T0zqD","comment":"Footer_comment__PVufM"};